/**
 * Echo Client Singleton
 * Provides a single instance of EchoClient accessible globally via window
 */

import { AnalyticsPlugin } from '@cash-web/shared-echo-util-plugin'

import { EchoClient } from './EchoClient'

/**
 * Get or create the global EchoClient singleton
 * Plugins should be registered separately via EchoPluginProvider
 */
export function getEchoClientInstance(): EchoClient {
  if (typeof window === 'undefined') {
    throw new Error('EchoClient can only be used in browser environment')
  }

  if (!window.__echoClientInstance) {
    // Create the singleton instance
    const client = new EchoClient()

    // Register plugins
    const analyticsPlugin = new AnalyticsPlugin(client)
    client.addPlugin(analyticsPlugin)

    window.__echoClientInstance = client

    // eslint-disable-next-line no-console
    console.log('[Echo] Singleton instance created')
  }

  return window.__echoClientInstance
}

/**
 * Check if EchoClient singleton exists
 */
export function hasEchoClientInstance(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  return !!window.__echoClientInstance
}

/**
 * Destroy the EchoClient singleton (for cleanup)
 */
export function destroyEchoClientInstance(): void {
  if (typeof window === 'undefined') {
    return
  }

  const win = window
  if (win.__echoClientInstance) {
    win.__echoClientInstance.stop()
    delete win.__echoClientInstance
    // eslint-disable-next-line no-console
    console.log('[Echo] Singleton instance destroyed')
  }
}
